import stylesheet from './TextCard.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

export class NXTTextCard extends CustomComponent {

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const card = document.createElement('div');
        card.classList.add('text-card-container')
        card.innerHTML = `
            <div class="card">
                <div class="icon-and-value-indicator">
                    <div class="icon"></div>
                    <div class="value-indicator">
                        <slot name="value"></slot>
                    </div>
                </div>
                <div class="title"></div>
                <div class="body"></div>
                <div class="cta">
                    <slot name="cta"></slot>
                </div>
            </div>
        `;
        this.cloneSlotContentIntoContainer(card.querySelector('.icon'), 'icon');
        this.cloneSlotContentIntoContainer(card.querySelector('.title'), 'title');
        this.cloneDefaultSlotContentIntoContainer(card.querySelector('.body'));
        this.setHasSlottedToParent(card);
        return card;
    }

}

customElements.define('nxt-text-card', NXTTextCard);
